export const SERVICE_AREAS = [
  { value: 'ads', label: 'Ads', color: '#8c4d78' },
  { value: 'seo', label: 'SEO', color: '#2a6e84' },
  { value: 'website', label: 'Website', color: '#1a2b4a' },
  { value: 'social', label: 'Social', color: '#7b5ea8' },
  { value: 'email', label: 'Email', color: '#9ecbd9' },
  { value: 'design', label: 'Design', color: '#8c4d78' },
  { value: 'copywriting', label: 'Copywriting', color: '#4a7ab5' },
  { value: 'account_management', label: 'Account Mgmt', color: '#5a7a6a' },
  { value: 'other', label: 'Other', color: '#8a9ab8' },
]

export const SERVICE_SUBAREAS = {
  ads: ['Google Ads', 'Facebook Ads', 'Landing Pages'],
  seo: ['On-Page SEO', 'AEO', 'Technical SEO', 'Keyword Research', 'Blog/Content'],
  website: ['Design', 'Development', 'CRO'],
  social: ['Content Creation', 'Scheduling', 'Engagement', 'Reels'],
  email: ['Newsletter', 'Automation', 'HubSpot'],
  design: ['Branding', 'Canva', 'Graphics'],
  copywriting: ['Web Copy', 'Ad Copy', 'Blog Writing'],
  account_management: ['Reporting', 'Client Comms', 'Dashboard'],
  other: [],
}

export const STATUSES = [
  { value: 'not_started', label: 'Not Started', icon: '○', color: '#94a3b8', bg: '#f1f5f9', done: false },
  { value: 'in_progress', label: 'In Progress', icon: '▶', color: '#2e7d6e', bg: '#e8f5f2', done: false },
  { value: 'blocked', label: 'Blocked', icon: '⚠', color: '#c94f4f', bg: '#fdf0f0', done: false },
  { value: 'needs_revision', label: 'Needs Revision', icon: '↩', color: '#c4962a', bg: '#fff8e1', done: false },
  { value: 'ready_for_review', label: 'Ready for Review', icon: '👁', color: '#8c4d78', bg: '#f9edf5', done: false },
  { value: 'internally_approved', label: 'Internally Approved', icon: '✓', color: '#2a6e84', bg: '#e8f5fa', done: false },
  { value: 'awaiting_client', label: 'Awaiting Client', icon: '⏳', color: '#7b5ea8', bg: '#f0eef8', done: false },
  { value: 'client_approved', label: 'Client Approved', icon: '✓✓', color: '#2e6e3a', bg: '#e8f5eb', done: false },
  { value: 'goes_live', label: 'Ready to Deploy', icon: '🚀', color: '#8c4d78', bg: '#f9edf5', done: false },
  { value: 'approved', label: 'Approved', icon: '✅', color: '#2e6e3a', bg: '#e8f5eb', done: true },
  { value: 'live', label: 'Live / Done', icon: '🟢', color: '#2e6e3a', bg: '#e8f5eb', done: true },
]

export const DONE_STATUSES = ['approved', 'live']
export const REVISION_STATUSES = ['needs_revision']

// Blog step 3 (client_review) counts as client-approved in any of these statuses.
// Matches the statuses that advance the blog to 'publishing'.
export const CLIENT_APPROVED_STATUSES = ['approved', 'live', 'client_approved']
export const BLOG_PUBLISH_WARNING = 'STOP, this has not yet been approved by the client. Check with the Account Director before proceeding with this step.'

export const ROLES = [
  { value: 'supervising_ad', label: 'Supervising AD' },
  { value: 'ad', label: 'Account Director' },
  { value: 'am', label: 'Account Manager' },
  { value: 'technician', label: 'Technician' },
]

export const APPROVAL_PATHS = [
  { value: 'none', label: 'No approval needed', description: 'Mark done and finished' },
  { value: 'internal', label: 'Internal approval only', description: 'Assigner approves then done' },
  { value: 'internal_then_live', label: 'Internal approval then goes live', description: 'Assigner approves then deployed' },
  { value: 'internal_client_live', label: 'Internal then client approval then goes live', description: 'Assigner approves then client approves then deployed' },
  { value: 'internal_then_client_fyi', label: 'Internal approval then send to client (FYI)', description: 'Assigner approves then client notified' },
]

export const getApprovalPath = (value) => APPROVAL_PATHS.find(a => a.value === value)
export const getServiceArea = (value) => SERVICE_AREAS.find(s => s.value === value)
export const getStatus = (value) => STATUSES.find(s => s.value === value)

// ── Termination reasons ─────────────────────────────────────────────────────
// Split by who can act on it, not by what the client said.
//
// "Financial" is deliberately NOT one bucket. A client who leaves at month 14
// because their practice shrank is a different problem from one who leaves at
// month 4 saying they can't justify the spend — the second is a value problem
// wearing a budget costume, and it IS coachable. So the categories below split
// on whether we had a fair shot at demonstrating worth.
export const TERMINATION_REASONS = [
  { value: 'value_not_shown',  label: "Couldn't justify the cost", group: 'controllable',
    hint: "They can afford it but don't see the return. Includes most 'financial' exits under ~12 months." },
  { value: 'results',          label: 'Results / performance', group: 'controllable',
    hint: 'The work did not deliver what they expected.' },
  { value: 'expectations',     label: 'Expectations mismatch', group: 'controllable',
    hint: 'Left early judging results before results were possible, or was sold something different.' },
  { value: 'relationship',     label: 'Relationship / communication', group: 'controllable',
    hint: 'Responsiveness, trust, or fit with the team.' },
  { value: 'cant_afford',      label: 'Genuinely cannot afford it', group: 'structural',
    hint: 'Practice shrinking, closing, non-payment. Money was the real constraint.' },
  { value: 'scope_complete',   label: 'Only wanted setup / one project', group: 'not_churn',
    hint: 'Never a retainer client. Setup-only, single campaign, took it in house.' },
  { value: 'paused',           label: 'Paused, intends to return', group: 'not_churn',
    hint: 'Seasonal or temporary. Flag them to follow up.' },
  { value: 'business_closed',  label: 'Business closed or never opened', group: 'not_churn', hint: '' },
  { value: 'other',            label: 'Other / unclear', group: 'unknown', hint: '' },
]

export const getTerminationReason = (v) => TERMINATION_REASONS.find(r => r.value === v)
export const REASON_GROUPS = {
  controllable: { label: 'Controllable', color: 'var(--red)' },
  structural:   { label: 'Structural',   color: '#c4962a' },
  not_churn:    { label: 'Not real churn', color: 'var(--text-muted)' },
  unknown:      { label: 'Unknown',      color: 'var(--text-muted)' },
}
// A deactivated user keeps all their historical data (tasks, comments, time
// entries) but can no longer log in. Use this to hide them from anything that
// assigns, mentions, or notifies people. Treats a missing is_active column as
// active, so the app keeps working before the database migration runs.
export const isActiveProfile = (p) => p?.is_active !== false
